import React, { useState, useEffect } from 'react'
import util from 'meinian-package/src/utils/util'
import { PLATFORM_CONFIG_ENUM } from 'meinian-package/src/component/enum'
import { toOriginLink } from '../../imageDetail/infoCase'

export default (props) => {
  const { platformId, children, className, style, item } = props
  const [currentDto, setCurrentDto] = useState({})

  useEffect(() => {
    setCurrentDto(item[PLATFORM_CONFIG_ENUM.get(item?.childPlatformId || platformId)?.dto] || {})
  }, [platformId, item?.childPlatformId])

  const href = toOriginLink(item?.childPlatformId || platformId, { ...item, ...currentDto })
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{ href ? <a
    onClick={() => {
      util.track('mn-origin-link', {
        module1: '卡片',
        module2: '站内款式原文',
      })
    }}
    style={style}
    href={href}
    target="_blank"
    rel="noreferrer"
    className={className}
  >{children || '跳转原文'}</a> : <span>{children}</span>}</>
}
